__turbopack_context__.v({
  "itemNotFound": "item-not-found-module-scss-module__dZ_QvG__itemNotFound",
  "itemNotFound_text": "item-not-found-module-scss-module__dZ_QvG__itemNotFound_text",
});
